/* ==========================================================
   EARTH ENERGY | PURE BOVINE COLOSTRUM LP
   File: assets/ee-col-lp.js
   Buy box logic, flavor + pack + purchase mode, add to cart.
   Verified against live PDP 2026-07-09 (prices in USD):
     1 Jar Unflavored  45661897916669   plan 6214779133
     1 Jar Chocolate   46375688601853   plan 6214779133
     3 Pack Unflavored 45661897949437   plan 6214811901
     3 Pack Chocolate  46375688634621   plan 6214811901
     6 Pack Unflavored 45661897982205   plan 6214844669
     6 Pack Chocolate  46375688667389   plan 6214844669
   ========================================================== */
document.addEventListener("DOMContentLoaded", function () {
  var PACKS = {
    "1": { name: "1 Jar", days: 30, jars: 1, plan: 6214779133,
           variants: { unflavored: 45661897916669, chocolate: 46375688601853 },
           once: { price: 59.95, compare: null },
           sub:  { price: 47.96, compare: 59.95, renew: 50.96 } },
    "3": { name: "3-Pack", days: 90, jars: 3, plan: 6214811901,
           variants: { unflavored: 45661897949437, chocolate: 46375688634621 },
           once: { price: 159.95, compare: 164.85 },
           sub:  { price: 127.96, compare: 159.95, renew: 135.96 } },
    "6": { name: "6-Pack", days: 180, jars: 6, plan: 6214844669,
           variants: { unflavored: 45661897982205, chocolate: 46375688667389 },
           once: { price: 269.95, compare: 329.70 },
           sub:  { price: 215.96, compare: 269.95, renew: 229.46 } }
  };
  var IMGS = {
    unflavored: "https://www.earthenergysupplementstore.com/cdn/shop/files/Colostrum_Site_1_jar.webp?v=1771780137",
    chocolate: "https://www.earthenergysupplementstore.com/cdn/shop/files/CC1Jar_402x_1e852015-1b3c-4a47-89ac-155e01ee0d35.webp?v=1771780137"
  };
  var state = { pack: "3", flavor: "unflavored", mode: "once" };
  var $ = function (id) { return document.getElementById(id); };
  var money = function (n) { return "$" + n.toFixed(2); };

  function render() {
    var p = PACKS[state.pack];
    var d = state.mode === "sub" ? p.sub : p.once;
    var perDay = d.price / p.days;
    var perJar = d.price / p.jars;

    $("eelp-price").textContent = money(d.price);
    if (d.compare && d.compare > d.price) {
      $("eelp-was").style.display = "inline";
      $("eelp-was").textContent = money(d.compare);
      $("eelp-save").style.display = "inline";
      $("eelp-save").textContent = "You save " + money(d.compare - d.price);
    } else {
      $("eelp-was").style.display = "none";
      $("eelp-save").style.display = "none";
    }
    $("eelp-meta").textContent = money(perJar) + " per jar \u00B7 $" + perDay.toFixed(2) + " per day \u00B7 " + p.days + "-day supply";

    var note = $("eelp-subnote");
    if (state.mode === "sub") {
      note.style.display = "block";
      note.textContent = "Renews at " + money(d.renew) + " (15% off for life). Skip, swap, or cancel anytime.";
      $("eelp-atc").textContent = "Subscribe & Save 20%";
    } else {
      note.style.display = "none";
      $("eelp-atc").textContent = "Add to Cart";
    }

    $("eelp-main-img").src = IMGS[state.flavor];
    $("eelp-sb-price").textContent = money(d.price);
    $("eelp-sb-meta").textContent = p.name + " \u00B7 $" + perDay.toFixed(2) + "/day";

    document.querySelectorAll("#eelp-packs .pack").forEach(function (el) {
      el.classList.toggle("on", el.getAttribute("data-pack") === state.pack);
      var pk = PACKS[el.getAttribute("data-pack")];
      var dd = state.mode === "sub" ? pk.sub : pk.once;
      el.querySelector('[data-role="pday"]').textContent = "$" + (dd.price / pk.days).toFixed(2) + "/day";
    });
    document.querySelectorAll("#eelp-flavors .flavor").forEach(function (el) {
      el.classList.toggle("on", el.getAttribute("data-flavor") === state.flavor);
    });
    document.querySelectorAll("#eelp-modes .mode").forEach(function (el) {
      el.classList.toggle("on", el.getAttribute("data-mode") === state.mode);
    });
  }

  document.querySelectorAll("#eelp-packs .pack").forEach(function (el) {
    el.addEventListener("click", function () { state.pack = el.getAttribute("data-pack"); render(); });
  });
  document.querySelectorAll("#eelp-flavors .flavor").forEach(function (el) {
    el.addEventListener("click", function () { state.flavor = el.getAttribute("data-flavor"); render(); });
  });
  document.querySelectorAll("#eelp-modes .mode").forEach(function (el) {
    el.addEventListener("click", function () { state.mode = el.getAttribute("data-mode"); render(); });
  });
  document.querySelectorAll(".eelp .thumb").forEach(function (el) {
    el.addEventListener("click", function () {
      $("eelp-main-img").src = el.getAttribute("data-img");
      document.querySelectorAll(".eelp .thumb").forEach(function (t) { t.classList.remove("on"); });
      el.classList.add("on");
    });
  });

  $("eelp-atc").addEventListener("click", function () {
    var btn = this;
    var p = PACKS[state.pack];
    var item = { id: p.variants[state.flavor], quantity: 1 };
    if (state.mode === "sub") item.selling_plan = p.plan;
    btn.disabled = true;
    btn.textContent = "Adding...";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) throw new Error("cart");
      window.location.href = "/checkout";
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = "Add to Cart";
      window.location.href = "/cart/add?id=" + p.variants[state.flavor] + "&quantity=1" + (state.mode === "sub" ? "&selling_plan=" + p.plan : "");
    });
  });

  document.querySelectorAll(".eelp .faq-q").forEach(function (q) {
    q.addEventListener("click", function () { q.parentElement.classList.toggle("open"); });
  });

  var buy = document.getElementById("buy");
  var bar = $("eelp-sticky");
  window.addEventListener("scroll", function () {
    bar.classList.toggle("show", buy.getBoundingClientRect().bottom < 0);
  }, { passive: true });

  document.querySelectorAll('.eelp a[href="#buy"]').forEach(function (a) {
    a.addEventListener("click", function (e) {
      e.preventDefault();
      buy.scrollIntoView({ behavior: "smooth" });
    });
  });

  render();
});
